import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  headerWrapper: {
    height: Theme.px(160),
    width: Theme.px(500),
  },
  rowWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  topRowWrapper: {
    bottom: Theme.px(65),
    marginLeft: Theme.px(120),
    marginRight: Theme.px(90),
    marginTop: Theme.px(110),
  },
});
